import { NavItemsType } from "../components/Navbar/types/NavItems";

export const navItems: NavItemsType = [
	{
		name: "Home",
		url: "/pjwrg",
	},
	{
		name: "Log In",
		url: `${process.env.REACT_APP_PORTAL_URL}/mst/login`,
	},
	{
		name: "States",
		isDropdown: true,
	},
	{
		name: "FAQ/Support",
		url: `${process.env.REACT_APP_TXN_URL}/helps/catalog/mst`,
		class: "ess-help",
	},
];
